import { getCompaniesFromRecNo } from "common/functions/api/companies";
import { handleError } from "common/functions/utilities";
import { useEffect } from "react";
import useSWR from "swr";

export const useCompanyWithRecNoHooks = (
  recNo: number | null | undefined,
  setFatal: ((error?: string | null | undefined) => void) | undefined
) => {
  const { data, error, isLoading } = useSWR(
    `companies of recNo ${recNo}`,
    () => {
      if (recNo) {
        return getCompaniesFromRecNo(recNo);
      }
      return [];
    }
  );

  useEffect(() => {
    if (error) {
      handleError(error, setFatal, "選択肢を読み込めませんでした。");
    }
  }, [error, setFatal]);

  return { companies: data ?? [], busy: isLoading } as const;
};
